import { render } from "./BillingMetricCard.vue?vue&type=template&id=23ec77da&scoped=true"
import script from "./BillingMetricCard.vue?vue&type=script&lang=js"
export * from "./BillingMetricCard.vue?vue&type=script&lang=js"

import "./BillingMetricCard.vue?vue&type=style&index=0&id=23ec77da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ec77da"]])

export default __exports__